import { route } from "quasar/wrappers";
import {
  createRouter,
  createMemoryHistory,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";
import routes from "./routes";

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

const convertCamelCaseToTitleCase = (str) => {
  return str
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => {
      return str.toUpperCase();
    })
    .trim();
};

export default route(function ({ store }) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === "history"
    ? createWebHistory
    : createWebHashHistory;

  const Router = createRouter({
    routes,
    // scrollBehavior: () => ({ left: 0, top: 0 }),
    scrollBehavior(to, from, savedPosition) {
      if (to.history) {
        return {
          el: to.history,
          left: 0,
          top: 90,
          behavior: "smooth",
        };
      } else {
        return { left: 0, top: 0 };
      }
    },

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    // history: createHistory(
    //   process.env.MODE === "ssr" ? void 0 : process.env.VUE_ROUTER_BASE
    // ),
    history: createHistory(process.env.VUE_ROUTER_BASE),
  });

  const themePages = [
    "/",
    "/demo",
    "/demo-1",
    "/demo-2",
    "/nepse-market-summary",
    "/charts",
    "/sector-chart",
    "/live-chart",
    "/fundamental-scan",
    "/brokers-analytics",
    "/stock-profile",
    "/broker-theme",
    "/fundamental-theme",
    "/stock-details",
    "/login",
  ];

  Router.beforeEach((to, from, next) => {
    const authenticate = store.state.authenticate;

    if (
      store.state.domain.domain != "chukul.com" &&
      store.state.domain.domain != "developer.chukul.com" &&
      store.state.domain.domain != "localhost" &&
      store.state.domain.domain != "127.0.0.1" &&
      store.state.domain.domain != "test-01.chukul.com"
    ) {
      if (!themePages.includes(to.path)) {
        next({
          name: "ErrorPage",
        });
      }
    }
    if (authenticate.isAuthenticated && to.path === "/login") {
      if (store.state.domain.domain == "chukul.com") {
        next({
          name: "Dashboard",
        });
      } else {
        next({
          name: "Dashboard",
        });
      }
    }

    if (
      to.matched.some((route) => route.meta.requiresAuth) &&
      !authenticate.isAuthenticated
    ) {
      if (store.state.domain.domain == "chukul.com") {
        next({
          name: "Dashboard",
        });
      } else {
        next({
          name: "Login",
        });
      }
    } else {
      next();
    }
  });

  Router.afterEach((to, from) => {
    const allStocks = store.state.core.allStocks;
    if (
      window.location.hostname == "chukul.com" ||
      window.location.hostname == "localhost"
    ) {
      if (to.name != "Login" || to.name != "Dashboard") {
        document.title = `${
          process.env.BASE_TITLE
        } - ${convertCamelCaseToTitleCase(to.name)}`;
      } else {
        document.title = `${
          process.env.BASE_TITLE
        } - ${convertCamelCaseToTitleCase(to.name)}`;
      }

      if (to.name == "Dashboard") {
        document.title = `
        ${process.env.BASE_TITLE} -
        Algo based Profit Optimizer and Decision Support System of Nepal Stock Market`;
      }
      if (to.name == "StockProfile") {
        document.title = process.env.BASE_TITLE;

        if (allStocks) {
          const stock = allStocks.find(
            (stock) => stock.symbol == to.query.symbol
          );
          const stockName = stock ? stock.name : " ";
          // document.title += ` - ${convertCamelCaseToTitleCase(to.name)} -
          // ${to.query.symbol} : ${stockName} `;

          document.title = `${to.query.symbol} : ${stockName}`;
        }
      }
    } else {
    }
  });

  return Router;
});
